import * as React from "react"
import { storyblokEditable, renderRichText } from "gatsby-source-storyblok"
import * as styles from "./richtext.module.css"

const Table = ({ blok }) => {
  const widthMap = {
    'small': 'max-w-screen-md',
    'mid': 'max-w-screen-lg',
    'large': 'max-w-screen-xl',
    'full': 'max-w-full'
  }
  const widthClass = widthMap[blok.width] ? widthMap[blok.width] : 'max-w-screen-lg'
  const tableWidth = {
    'small': 'w-[640px]',
    'mid': 'w-[1024px]',
    'large': 'w-[1280px]',
    'full': 'w-full'
  }
  const tableWithClass = tableWidth[blok.width] ? tableWidth[blok.width] : 'w-[1024px]'
  const columnConfig = blok.columnConfig ? JSON.parse(blok.columnConfig) : {}
  // console.log(blok)
  // console.log(columnConfig)

  return (  
    <div className={`${widthClass} container flex flex-col justify-center mx-auto p-3`} {...storyblokEditable(blok)}
      style={{ 
        paddingTop: `${blok.paddingTop}px`, paddingBottom: `${blok.paddingBottom}px`, 
        marginTop: `${blok.marginTop}px`, marginBottom: `${blok.marginBottom}px` }}>
      {blok.title && 
      <h2 className="font-bold text-xl">{blok.title}</h2>}

      {blok.description && 
      <div className={`py-3`} dangerouslySetInnerHTML={{ __html: renderRichText(blok.description) }} />}
      
      <div className="overflow-x-auto">
        <table className={`table-auto text-left ${tableWithClass} md:w-full`} style={{
          fontSize: `${blok.fontSize}px`,
        }}>
          <thead className="border-black border-b-4">
            <tr>{blok.table.thead.map((th, i) => (<th className={`text-nowrap px-5 py-2 border-black ${i > 0 ? 'border-l' : ''}`} key={i}>{th.value}</th>))}</tr>
          </thead>
          <tbody>
            {blok.table.tbody.map((tr, i) => (
              <tr key={i} className={`${ i % 2 === 0 ? 'bg-gray-100' : ''}`}>
                {tr.body.map((td, j) => (
                <td key={j} 
                  className={`align-top px-5 py-2 border-black border-t ${j > 0 ? 'border-l' : ''} ${columnConfig[j+1]}`}
                  dangerouslySetInnerHTML={{ __html: td.value}}>
                </td>))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {blok.notes && 
      <div className={`${styles.richText}`} dangerouslySetInnerHTML={{ __html: renderRichText(blok.notes) }} />}
    </div>
  )
}

export default Table
